import React from 'react';
import { toDisplayTimeString } from '../../../helpers/moment-ex';
import { NumberLoader } from '../../widgets/Loader';

export const KPINumber = ({ titleClassName, title, isLoading, value }) =>
    <>
        <span className="txt-num word-wrap">
            {isLoading && <NumberLoader />}
            {!isLoading ? value : ""}
        </span>
        <br />
        <span className={`txt-label ${titleClassName}`}>{title}</span>
    </>;

export const NonTruckKPI = props => {
    const { kpiData: d, unit, settings } = props;
    const label = `state-${d.egState}`;

    return (<>
        <div className="row">
            <div className={`${col(6)} p-0 word-wrap`}>
                <KPINumber
                    title="Planned"
                    titleClassName={label}
                    value={unit.toRoundOfArea(d.plannedAcres)}
                    isLoading={d.isRequesting}
                />
            </div>
            <div className={`${col(6)} p-0 word-wrap`}>
                <KPINumber
                    title={`${settings.areaShortName} Actual`}
                    titleClassName={label}
                    value={unit.toRoundOfArea(d.completedAcres)}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
        <div className="row">
            <div className={`${col(6)} p-0 mt-2 word-wrap`}>
                <KPINumber
                    title="Utilization"
                    value={`${Math.round(d.utilization)}%`}
                    isLoading={d.isRequesting}
                />
            </div>
            <div className={`${col(6)} p-0 mt-2 word-wrap`}>
                <KPINumber
                    title={settings.speedShortName}
                    value={(d.speed && d.speed.toString().trim() !== '-') ? unit.toRoundOfSpeed(d.speed) : 0}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
    </>);
};

export const TruckKPI = props => {
    const { kpiData: d, unit, settings } = props;

    return (<>
        <div className="row">
            <div className={`${col(5)} p-0`}>
                <KPINumber
                    title={settings.weightShortName}
                    value={unit.toRoundOfWeight(d.loadWeight)}
                    isLoading={d.isRequesting}
                />
            </div>
            <div className={`${col(3)} p-0 `}>
                <KPINumber
                    title={`${settings.speedShortName === "mph" ? "miles" : "km"}`}
                    value={d.distanceTravelled}
                    isLoading={d.isRequestingTravelKpi}
                />
            </div>
            <div className={`${col(1)} p-0`} style={{ borderLeft: "2px solid #c0c2c0", marginTop: "3px" }}></div>
            <div className={`${col(3)} p-0`}>
                <KPINumber
                    title={settings.speedShortName}
                    value={(d.speed && d.speed.toString().trim() !== '-') ? unit.toRoundOfSpeed(d.speed) : 0}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
        <div className="row">
            <div className={`${col(5)} p-0 mt-2`}>
                <KPINumber
                    title="Loads"
                    value={d.loads}
                    isLoading={d.isRequesting}
                />
            </div>
            <div className={`${col(7)} p-0 mt-2`}>
                <KPINumber
                    title="Avg. Roundtrip Load Time"
                    value={toDisplayTimeString(d.avgRoundTripLoadTime)}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
    </>);
};

export const BalerKPI = props => {
    const { kpiData: d, unit, settings } = props;

    return (<>
        <div className="row">
            <div className={`${col(5)} p-0 mt-2`}>
                <KPINumber
                    title="Bales"
                    value={d.bales}
                    isLoading={d.isRequesting}
                />
            </div>
            <div className={`${col(7)} p-0 mt-2`}>
                <KPINumber
                    title="Avg. Bale Time"
                    value={toDisplayTimeString(d.avgBaleTime)}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
        <div className="row">
            {/* <div className={`${col(5)} p-0 mt-2`}>
                <span className="txt-num word-wrap">{unit.toRoundOfWeight(d.loadWeight)}</span><br />
                <span className="txt-label">{settings.weightShortName}</span>
            </div> */}
            <div className={`${col(7)} p-0 mt-2`}>
                <KPINumber
                    title={settings.speedShortName}
                    value={(d.speed && d.speed.toString().trim() !== '-') ? unit.toRoundOfSpeed(d.speed) : 0}
                    isLoading={d.isRequesting}
                />
            </div>
        </div>
    </>);
};

export const SensorBox = props => {
    const { egInfo, kpiData: sensor } = props;
    const batteryLevel = getBatteryLevel(sensor.batteryPercent);
    const moistureLevel = getMoistureLevel(sensor.grainMoisture);
    const fuelLevel = getFuelLevel(sensor.fuelLevel);
    const moistureUrl = require(`../../../../assets/images/ic_moisture_${moistureLevel}.svg`);
    const ptoRpmUrl = sensor.ptoRPMState ? require("../../../../assets/images/pto_rpm.svg") :
        require("../../../../assets/images/pto_rpm_stop.svg");
    const isSensor = (sensor.batteryPercent !== null || sensor.connected !== null
        || sensor.fuelLevel !== null || sensor.ptoRPMSpeed !== null
        || sensor.grainMoisture !== null || sensor.grainYield !== null);

    return <>
        {isSensor &&
            (<div className="d-flex d-event-status">
                <div className="icn-bg-color" title={`${sensor.connected ? "Wifi connected" : "Wifi disconnected"}`}>
                    <i className={`fa fa-wifi ${sensor.connected ? '' : 'strike-icon'}`} />
                </div>
                <div className="icn-bg-color" title={`Battery level ${sensor.batteryPercent}%`}>
                    <i className={`fa fa-battery-${batteryLevel.state} mr-1`} style={{ color: batteryLevel.color }} />
                    {sensor.batteryPercent}%
                </div>
                {(egInfo.equipmentTypeId === 6) &&
                    <>
                        <div className="icn-bg-color" title={`Grain moisture ${sensor.grainMoisture || 0}%`}>
                            <img src={moistureUrl} className="mr-1 mb-1" alt="" />{sensor.grainMoisture || 0}%
                        </div>
                        <div className="icn-bg-color" title={`Grain yield ${sensor.grainYield || 0} bu/ac`}>
                            {sensor.grainYield || 0} bu/ac
                        </div>
                    </>}
                {(!egInfo.isTruck && sensor.ptoRPMSpeed !== null) && <>
                    <div className="icn-bg-color" title={`${sensor.ptoRPMState ? sensor.ptoRPMSpeed + " rpm" : ""}`}>
                        <img src={ptoRpmUrl} className={`icon-pto ${!sensor.ptoRPMState && "disconnect"}`} alt="" />
                        {sensor.ptoRPMState && `${sensor.ptoRPMSpeed}`} rpm
                    </div>
                </>}
                {(!egInfo.isTruck) && <>
                    <div className="icn-bg-color" title={`Fuel level ${sensor.fuelLevel !== null ? `${sensor.fuelLevel}%` : "N/A"}`}>
                        <i className={`icon icon-fuel mr-1`} style={{ color: fuelLevel.color }} />
                        {sensor.fuelLevel !== null ? `${sensor.fuelLevel}%` : "N/A"}
                    </div>
                </>}
            </div>)}
    </>;
};

const col = (size) => {
    return `col-xl-${size} col-lg-${size} col-md-${size} col-sm-${size}  col-xs-${size}`;
};

const getBatteryLevel = level => {
    if (level >= 90 && level <= 100) return { state: 4, color: "#4caf50" };
    else if (level >= 70 && level < 90) return { state: 3, color: "#4caf50" };
    else if (level >= 50 && level < 70) return { state: 2, color: "#4caf50" };
    else if (level >= 25 && level < 50) return { state: 1, color: "#f7a32b" };
    else if (level >= 11 && level < 25) return { state: 1, color: "#FF0000" };
    else if (level >= 0 && level < 11) return { state: 0, color: "#FF0000" };
    else return { state: 0, color: "#FF0000" };
};

const getMoistureLevel = level => {
    if (level >= 75 && level <= 100) return 100;
    else if (level >= 50 && level < 75) return 75;
    else if (level >= 25 && level < 50) return 50;
    else if (level > 0 && level < 25) return 25;
    else return 0;
};

const getFuelLevel = level => {
    if (!level) return { color: "#212629" };
    if (level > 75 && level <= 100) return { color: "#4caf50" };
    else if (level > 25 && level <= 75) return { color: "#f7a32b" };
    else if (level >= 0 && level <= 25) return { color: "#FF0000" };
    else return { color: "#f74225" };
};